export default {
  nofund: {
    padgeTitle: '页面未找到',
    title: '404 | 页面未找到',
    summary: '抱歉，找不到您要访问的页面',
    btn: ['返回首页', '帮助中心']
  }
}
